import { CheckCircleIcon, XCircleIcon } from '@heroicons/react/24/outline';
import { cn } from '@jobcost-monorepo/utils';
import { ReactElement } from 'react';

type AlertType = 'success' | 'error';

interface Props {
  type: AlertType;
  message: string;
}

const Alert: React.FC<Props> = ({ type, message }) => {
  const getIcon = (): ReactElement => {
    if (type === 'success') {
      return <CheckCircleIcon className="h-6 w-6" aria-hidden="true" />;
    }

    return <XCircleIcon className="h-6 w-6" aria-hidden="true" />;
  };

  const getTextColor = (): string => {
    return type === 'success' ? 'text-[#166534]' : 'text-[#b91c1c]';
  };

  const getBgColor = (): string => {
    return type === 'success' ? 'bg-[#dcfce7]' : 'bg-[#fee2e2]';
  };

  return (
    <div
      className={cn(
        'fixed bottom-7 right-5 flex items-center w-full max-w-xs p-4 space-x-4 rtl:space-x-reverse divide-x rtl:divide-x-reverse divide-gray-200 rounded-lg shadow',
        getBgColor(),
        getTextColor(),
      )}
      role="alert"
    >
      {getIcon()}
      <div className="ps-4 text-sm font-normal">{message}</div>
    </div>
  );
};

export default Alert;
